module.exports = __webpack_public_path__ + "media/images/pic/groups/kindergarten-4e9c943d493436ae7761f659aaa55fce.jpg";